export * from './app-sidebar-minimizer.component';



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/components/app-sidebar-minimizer/index.ts